import { Pagination, PaginationProps } from '@trukt/ui/Pagination';

interface OrderListPaginationProps extends Pick<
  Required<PaginationProps>,
  'pageSize' | 'currentPage' | 'onPageSelect' | 'onPageSizeSelect' | 'isNextPageAvailable'
> {}
export const OrderListPagination = (props: OrderListPaginationProps) => {
  return (
    <div className="flex items-center justify-end gap-2">
      <Pagination isInfinite {...props} />
    </div>
  );
};
